import { motion } from 'framer-motion';
import useReducedMotion from '../../hooks/useReducedMotion';

const offsets = {
  up: { y: 26, x: 0 },
  down: { y: -26, x: 0 },
  left: { x: 26, y: 0 },
  right: { x: -26, y: 0 },
  none: { x: 0, y: 0 },
};

/**
 * Fade-and-slide a block into view the first time it is scrolled to.
 * Renders statically when the user prefers reduced motion.
 */
export default function Reveal({
  children,
  direction = 'up',
  delay = 0,
  duration = 0.6,
  className,
  as = 'div',
}) {
  const reducedMotion = useReducedMotion();
  const MotionTag = motion[as] || motion.div;

  if (reducedMotion) {
    const Tag = as;
    return <Tag className={className}>{children}</Tag>;
  }

  const offset = offsets[direction] || offsets.up;

  return (
    <MotionTag
      className={className}
      initial={{ opacity: 0, ...offset }}
      whileInView={{ opacity: 1, x: 0, y: 0 }}
      viewport={{ once: true, amount: 0.2 }}
      transition={{ duration, delay, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </MotionTag>
  );
}
